export default {
    parent: 'ApplicationLayout',
    template: `
        <header-evaluation-evaluation ng-if="vm.$state.includes('evaluation.evaluation.*')"
        class="header-wrapper header-fixed"></header-evaluation-evaluation>
        <header-evaluation-report ng-if="vm.$state.includes('evaluation.report')"
        class="header-wrapper header-fixed"></header-evaluation-report>
        <div class="col00 small ">
            <ui-view class="body-wrapper"></ui-view>
        </div>
        <footer class="footer-wrapper"></footer>
    `,
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/layouts/evaluation/index.js